
class Queue<Data> {
  /**
   * 存放回调事件
   */
  map = new Map<string, Data>();
  /**
   * 存放事件执行的队列
   */
  queue: any[] = [];
  /**
   * 生成hash
   * @param {number} len 生成hash的长度
   * @return 生成的hash
   */
  getHash (len: number = 6) {
    return Math.random().toString(36).substr(2, len);
  }
  /**
   * 生成任务id
   * @returns 
   */
  generateTaskId () {
    let taskId = this.getHash();
    while(this.map.get(taskId)) {
      taskId = this.getHash();
    }
    return taskId;
  }
  /**
   * 判断队列是否为空
   * @returns 
   */
  isEmpty () {
    return this.queue.length === 0;
  }
  /**
   * 将任务推入栈
   * @param {Data} data 任务执行方法
   * @param {string} key 任务的id
   * @returns 人物id
   */
  push (data: Data, key?: string) {
    const taskId = key || this.generateTaskId();
    this.queue.unshift(taskId);
    this.map.set(taskId, data);
    return taskId;
  }
  /**
   * 将任务推出栈
   * @returns 需要执行的任务
   */
  pop () {
    const taskId = this.queue.pop();
    const task = this.map.get(taskId);
    this.map.delete(taskId);
    return task;
  }
  get (taskId: string) {
    return this.map.get(taskId);
  }
  delete (taskId: string) {
    this.queue = this.queue.filter(t => t !== taskId);
    const task = this.map.get(taskId);
    this.map.delete(taskId);
    return task;
  }
}

export default Queue;
